<template>
  <v-dialog v-model="value" persistent max-width="500px">
    <v-form
      ref="inviteForm"
      v-model="valid"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('companies.invite_dialog_title', {company: company.name})}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row >
              <v-col cols="12">
                <v-text-field
                  prepend-icon="email"
                  v-model="email"
                  :label="$t('locations.email')+'*'"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  auto-grow
                  rows="1"
                  prepend-icon="message"
                  :label="$t('companies.message')"
                  v-model="message"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('input', false)">{{ $t('buttons.close') }}</v-btn>
          <v-btn color="accent" text @click="sendInvite()">{{ $t('companies.invite') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CompanyInviteDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    company: Object
  },
  data () {
    return {
      email: '',
      message: '',
      valid: true,
      emailRules: [
        value => !!value || this.$i18n.t('general.required_field'),
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('general.email_not_valid')
      ]
    }
  },
  computed: {
    ...mapState(['signedInCompany'])
  },
  methods: {
    sendInvite () {
      if (this.$refs['inviteForm'].validate()) {
        // TODO: send invite to email (API request)
        // TODO: show snackbar
        console.log('Company name - inviter:', this.signedInCompany.name)
        console.log('Company name - invited:', this.company.name)
        console.log('email:', this.email)
        console.log('message:', this.message)
        this.$emit('input', false)
        this.email = ''
        this.message = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
